import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloFlux, cleanAloFlux } from '@/models/alo/AloFlux'
import { AloItemflux, cleanAloItemflux } from '@/models/alo/AloItemflux'
import { AloDiscountRatio, cleanAloDiscountRatio } from '@/models/alo/AloDiscountRatio'
import { AloMercurial, cleanAloMercurial } from '@/models/alo/AloMercurial'

export default {
  getAllFlux(): AxiosPromise<AlrContainer<Array<AloFlux>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFlux>>
      }]
    })
  },
  getFlux(id:number):AxiosPromise<AlrContainer<AloFlux>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloFlux>
      }]
    })
  },
  saveFlux(flux:AloFlux):AxiosPromise<AlrContainer<AloFlux>> {
    cleanAloFlux(flux)
    if(flux.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Flux/${flux.id}`, 
        method: 'PUT',
        data: flux,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFlux>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Flux`, 
        method: 'POST',
        data: flux,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFlux>
        }]
      })    
    }
  },
  deleteFlux(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloFlux>
      }]
    })
  },
  getItemFlux(id:number): AxiosPromise<AlrContainer<Array<AloItemflux>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}/itemflux`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloItemflux>>
      }]
    })
  },
  saveItemFlux({id,fluxItems}:{id:number,fluxItems:Array<AloItemflux>}):AxiosPromise<AlrContainer<Array<AloItemflux>>> {  
    fluxItems.forEach(it => cleanAloItemflux(it))    
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}/itemflux`,  
      method: 'PUT',
      data: fluxItems,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloItemflux>>
      }]
    })    
  },
  getDiscountRatio(id:number): AxiosPromise<AlrContainer<Array<AloDiscountRatio>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}/discount`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloDiscountRatio>>
      }]
    })
  },
  saveDiscountRatio({id,discountItems}:{id:number,discountItems:Array<AloDiscountRatio>}):AxiosPromise<AlrContainer<Array<AloDiscountRatio>>> {  
    discountItems.forEach(it => cleanAloDiscountRatio(it))    
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}/discount`,  
      method: 'PUT',
      data: discountItems,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloDiscountRatio>>
      }]
    })    
  },
  getMercurial(id:number): AxiosPromise<AlrContainer<Array<AloMercurial>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}/mercurial`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMercurial>>
      }]
    })
  },
  saveMercurial({id,mercurials}:{id:number,mercurials:Array<AloMercurial>}):AxiosPromise<AlrContainer<Array<AloMercurial>>> {  
    mercurials.forEach(it => cleanAloMercurial(it))    
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Flux/${id}/mercurial`,  
      method: 'PUT',
      data: mercurials,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloMercurial>>
      }]
    })    
  },
}